import { Reveal } from "@/components/Reveal";

const STEPS = [
  { n: "01", title: "Consultation", text: "We listen to your goals, requirements and vision for the property." },
  { n: "02", title: "Site Assessment", text: "A detailed review of the property, structure and scope of works." },
  { n: "03", title: "Project Planning", text: "Clear scheduling, budgeting and coordination of trusted trades." },
  { n: "04", title: "Construction", text: "Professionally managed works with regular progress updates." },
  { n: "05", title: "Completion", text: "Final quality checks, finishing and a handover done properly." },
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="relative bg-[#050B14] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-16 text-center">
        <div className="mb-6 flex items-center justify-center gap-4">
          <span className="h-px w-12 bg-gradient-to-r from-transparent to-[#C5A059]" />
          <span className="text-[11px] font-semibold uppercase tracking-[0.35em] text-[#C5A059]">How We Work</span>
          <span className="h-px w-12 bg-gradient-to-l from-transparent to-[#C5A059]" />
        </div>
        <h2 className="font-serif text-3xl font-light uppercase leading-snug tracking-tight text-white sm:text-4xl lg:text-5xl">
          Our <span className="gold-text-gradient">Process</span>
        </h2>
      </Reveal>

      <div className="relative grid gap-10 sm:grid-cols-2 lg:grid-cols-5 lg:gap-6">
        <div className="absolute left-0 right-0 top-6 hidden h-px bg-gradient-to-r from-transparent via-[#C5A059]/40 to-transparent lg:block" />
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div data-testid={`process-step-${s.n}`} className="group relative text-center lg:text-left">
              <div className="relative mx-auto flex h-12 w-12 items-center justify-center border border-[#C5A059]/50 bg-[#050B14] font-mono text-sm text-[#C5A059] transition-all duration-500 group-hover:bg-[#C5A059] group-hover:text-[#050B14] lg:mx-0">
                {s.n}
              </div>
              <h3 className="mt-6 font-serif text-xl font-medium uppercase tracking-wide text-white">
                {s.title}
              </h3>
              <p className="mt-3 text-sm font-light leading-relaxed text-slate-400">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
